<template>
  <div id="quiz-view" class="view quiz">
    <question-view :at-question="atQuestion" :current-question="currentQuestion" @answer="answered" @back="backOne" />
    <question-view-desktop :at-question="atQuestion" :current-question="currentQuestion" @answer="answered" @back="backOne" />
  </div>
</template>

<script>
import QuestionView from '@/components/QuestionView'
import QuestionViewDesktop from '@/components/QuestionViewDesktop'
import questions from '@/data/questions.json'
export default {
  name: 'QuizView',
  data () {
    return {
      atQuestion: 0,
      questions: questions
    }
  },
  props: [],
  computed: {
    currentQuestion () {
      return this.questions[this.atQuestion]
    }
  },
  methods: {
    backOne () {
      this.atQuestion--
    },
    answered (answer) {
      if (this.atQuestion >= 10) {
        this.$router.push('done')
      }
      this.atQuestion++
    }
  },
  mounted () {
  },
  components: {QuestionView, QuestionViewDesktop}
}
</script>

<style scoped>
.view {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/QuizView.vue